// extracted by mini-css-extract-plugin
export default {"emote":"_1ihzk"};